import React, { Component } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { uploadFiles } from '../../util/fileUpload';
import { FormattedMessage } from '../../util/reactIntl';
import { IconCamera, IconClose, IconSpinner } from '../index';
import tick from '../../assets/tripPage/tick.svg';
import disabledTick from '../../assets/tripPage/tick-disabled.svg';
import css from '../../components/TripPanel/SectionsCarPhotos.css';
import imageCompression from 'browser-image-compression';
const ACCEPT_TYPE = 'image/*';

/**
 * isPickUp: boolean
 * Show that modal is pickup modal
 * isShowUpload: boolean
 * Show that transaction is show upload or not
 */

class UploadSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUploading: false,
      currentIsUploading: [],
      index: 0,
      uploadFileError: false,
      uploadedPhoto: [],
    };
    this.uploaded = [];
  }

  compressImage = async (file) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    try {
      if (file.size / 1024 / 1024 < options.maxSizeMB) {
        // Skip compression if file is already smaller than maxSizeMB
        return file;
      }
      const compressedFile = await imageCompression(file, options);
      return compressedFile;
    } catch (error) {
      console.error('Image compression error:', error);
      return file;
    }
  };

  uploadOtherFiles = async (files, currentUser) => {
    const uploadSingleFile = async (file, index) => {
      if (!file) return Promise.resolve({});

      const compressedFile = await this.compressImage(file);
      const { id } = currentUser;
      const formData = new FormData();
      formData.append('file', compressedFile, compressedFile.name);
      formData.append('userId', id.uuid);
      formData.append('tripPhotos', true);

      return uploadFiles(formData)
        .then(response => {
          if (response.status !== 200) {
            return Promise.reject(response);
          }
          return response.json();
        });
    };

    const promises = files.map((file) => uploadSingleFile(file.file, file.index));
    return Promise.all(promises);
  };

  handleUploadFiles = (files, currentUser) => {
    if (files.length) {
      this.setState({
        isUploading: true,
        uploadFileError: false,
        currentIsUploading: [
          ...this.state.currentIsUploading,
          { id: this.props.index, status: true },
        ],
      });
      // return this.uploadFirstFile(files[0], currentUser)
      //   .then(() => {
      return this.uploadOtherFiles(files, currentUser)
        // })
        .then((response) => {
          const uploadedPhoto = response.map((item, index)=> {
            return {
              fileUrl: item.url,
              note: item.note,
              type: this.props.type,
              id: this.props.id,
              isPickUp: true,
              timestamp: Date.now() + index,
              isJustUploaded: true,
            }
          })

          this.props.setActivePhotoSection(uploadedPhoto);

          this.setState({
            isUploading: false,
            uploadedPhoto,
            currentIsUploading: [
              ...this.state.currentIsUploading,
              {
                id: this.props.index,
                status: true,
              },
            ],
          }, () => {
            this.handleAddPhoto();
          });
        })
        .catch(e => {
          console.log('ERROR', e);
          this.setState({ uploadFileError: true, isUploading: false });
        });
    }
    return Promise.resolve({});
  };

  handleAddPhoto = currentIndex => {
    const {
      fileUrl,
      note,
      tripPhotos,
      isCustomer,
      isPickUp,
      type,
      files,
      setData,
      existedPhotos,
    } = this.props;
    const {uploadedPhoto} = this.state

    const allPhotos = []
    uploadedPhoto.map(i => {
      const data = {
        fileUrl: i.fileUrl,
        note: note || (tripPhotos[0] && tripPhotos[0].note) || existedPhotos[0] && existedPhotos[0].note,
        timestamp: new Date().getTime(),
        isCustomer: isCustomer,
        isPickUp: isPickUp,
        [type]: true,
      };

      allPhotos.push(data);

    })
    this.props.handleAddPhoto(allPhotos);
  };

  handleRemovePhoto = timestamp => {
    this.props.handleRemovePhoto(timestamp);
  };

  handleClickUpload = () => {
    this.inputElement.click();
  };

  handleUploadPhoto = file => {
    const { currentUser } = this.props;

    if (!file) {
      return;
    }
    let data = new FormData();
    data.append('file', file, file.name);
    data.append('userId', currentUser && currentUser.id && currentUser.id.uuid);
    data.append('tripPhotos', true);
    this.setState({
      isUploading: true,
    });

    uploadFiles(data)
      .then(response => {
        const code = response.status;
        if (code !== 200) {
          return null;
        }
        return response.json();
      })
      .then(jsonResponse => {
        if (!jsonResponse.url) {
          this.setState({
            isUploading: false,
          });
        } else {
          this.props.setData({ fileUrl: jsonResponse.directLink });
          this.setState({
            isUploading: false,
          });
        }
      })
      .catch(e => {
        this.setState({
          isUploading: false,
        });
      });
  };

  render() {
    const {
      isShowUpload,
      isCustomer,
      isPickUp,
      setData,
      files,
      file,
      fileUrl,
      note,
      tripPhotos,
      existedPhotos,
      pickUpReading,
      dropOffReading,
      index,
      intl,
      type,
      onNoteChange,
      title,
      inboxLabel,
      inboxPlaceholder,
      pickUpOdometer,
      isFuelInclusion,
      isAdminAction
    } = this.props;

    const showYourPhotos = existedPhotos.filter(
      photo => photo[type] === true
    );
    const hasJustUploadedTripPhotos = tripPhotos.filter(photo => isPickUp ? !!photo.isPickUp : !photo.isPickUp);
    const pickUpPhotos = showYourPhotos && showYourPhotos.length > 0 ? [...showYourPhotos] : [...hasJustUploadedTripPhotos];

    const uploadTextLabel = (
      <FormattedMessage
        id={inboxLabel || 'Remarks (optional)'}
      />
    );
    const uploadPlaceholder = inboxPlaceholder ? inboxPlaceholder: intl.formatMessage({
      id: 'SectionUploadCarStatus.uploadPlaceholder',
    });

    const noteChange = (e) => {
      onNoteChange(e.target.value, type);
    }
    const formatPercentage = (value) => {
      const num = Number(value);
      return Number.isInteger(num) ? `${num}%` : `${num.toFixed(1)}%`;
    };
    const getDisplayNote = (noteText) => {
      return noteText ? (title === 'Fuel Gauge Photo' ? formatPercentage(noteText) : noteText) : '';
    };

    const displayNote = getDisplayNote(tripPhotos[0]?.note || '');
    const displayExistedPhotosText = getDisplayNote(existedPhotos[0]?.note || '');
    console.log('isAdminAction', isAdminAction)

    const odoMeterInputProps = {
      type: "number",
      min:0,
      max:999999,
    }

    const fuelGaugeInputProps = {
      type: "number",
      min:0,
      max:100
    }

    const isValidNumber = (value) => {
      const regex = /^-?\d+(\.\d+)?$/
      return regex.test(value);
    };

    const inputConstraints = {
      'odometerPhotos': (value) => isValidNumber(value) && value >= 0 && value <= 999999,
      'fuelGaugePhotos': (value) => isValidNumber(value) && value >= 0 && value <= 100,
    };

    const onChangeInput = (e) => {
      const { value } = e.target;
      if (type === 'odometerPhotos' && !isPickUp) {
        this.props.customDropOffReadingByAdmin(value);
      }
      if (value === "") {
        setData({ note: value });
        return;
      }

      const isValid = inputConstraints[type] ? inputConstraints[type](value) : true;
      if (!isValid) {
        console.log('Invalid input, keeping existing note state:', note);
        setData({ note: note }); // Keep existing note if invalid
        return;
      }

      console.log('Setting new note state:', value);
      setData({ note: value }); // Update the note state when valid
    };

    return (
      <div className={css.content}>
        <div className={css.pickUpPhotosHolder}>
          {!isCustomer && !isShowUpload && (
            <div className={classNames(css.uploadContainer, css.pickUpPhotosUploadContainer)}>
              <div className={css.uploadBox} onClick={this.handleClickUpload}>
                <div className={css.uploadBoxInner}>
                  {/*{file && <img src={file} className={css.imageFromFileWrapper} />}*/}
                  {file && this.state.isUploading && (
                    <div className={css.uploadLoading}>
                      <IconSpinner />
                    </div>
                  )}
                  {<IconCamera rootClassName={css.uploadIcon} />}
                </div>
              </div>
              <input
                accept={ACCEPT_TYPE}
                className={css.inputField}
                type="file"
                name="uploadPhotoStatus"
                id="uploadPhotoStatus"
                multiple={true}
                onChange={e => {
                  if (e.target.files[0]) {
                    // this.handleUploadPhoto(e.target.files[0])
                    const files = Array.from(e.target.files).map((file, index) => ({
                      index,
                      file,
                    }));
                    this.handleUploadFiles(files, this.props.currentUser);
                    setData({
                      file: Object.values(e.target.files).map(i => URL.createObjectURL(i)),
                      files: e.target.files,
                    });
                  }
                  // setTimeout(() => this.handleAddPhoto(index), 3000);
                }}
                ref={input => (this.inputElement = input)}
              />
            </div>
          )}

          {isCustomer && isPickUp && <div className={css.pickUpReading}>{pickUpReading}</div>}
          {isCustomer && !isPickUp && <div className={css.pickUpReading}>{dropOffReading}</div>}
          <div className={classNames(css.photosContainer, css.pickUpPhotosContainer)}>
            {pickUpPhotos.map(photo => (
              <div className={css.photoWrapper} key={photo.fileUrl}>
                <div className={css.photoWrapperInner}>
                  {photo.isJustUploaded && (
                    <div
                      className={css.removePhotoBtn}
                      onClick={() => this.handleRemovePhoto(photo.fileUrl)}
                    >
                      <IconClose size={'small'} />
                    </div>
                  )}
                  <img
                    src={photo.fileUrl}
                    className={css.tripPhoto}
                    onClick={() => window.open(photo.fileUrl, '_blank')}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div>
          {type === 'odometerPhotos' &&
            pickUpOdometer &&
            (isFuelInclusion ? (
              <div className={css.odometerReading}>
                <p>
                  This is a Fuel inclusion trip. Make sure the odometer reading is higher than the
                  pickup reading - <b>{pickUpOdometer}</b>. This will be used to calculate fuel
                  charges. If unsure, check with the guest or host.
                </p>
              </div>
            ) : (
              <div className={css.odometerReading}>
                <p>
                  Make sure the value you're entering is higher than the pickup odometer reading –{' '}
                  <b>{pickUpOdometer}</b>
                </p>
              </div>
            ))}
          <label className={css.inputTextLabel}>{uploadTextLabel}</label>
          <input
            type={'text'}
            className={css.inputText}
            id="noteCarPhotoStatus"
            name="noteCarPhotoStatus"
            onChange={onChangeInput}
            onBlur={noteChange}
            value={isAdminAction ? note : note || displayNote || displayExistedPhotosText}
            placeholder={uploadPlaceholder}
            ref={input => (this.inputNote = input)}
            disabled={isCustomer}
            {...(type === 'odometerPhotos' && odoMeterInputProps)}
            {...(type === 'fuelGaugePhotos' && fuelGaugeInputProps && !isCustomer)}
          />
        </div>
        {this.state.uploadFileError ? (
          <p className={css.uploadError}>
            <FormattedMessage id="SectionUploadCarStatus.uploadError" />
          </p>
        ) : null}
      </div>
    );
  }
}

class SectionCarPhotos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      file: null,
      fileUrl: '',
      note: '',
    };
  }

  handleUploadPhoto = data => {
    this.props.setTripPhotos([...this.props.tripPhotos, ...data ]);
  };
  handleRemovePhoto = fileUrl => {
    const newTripPhotos = this.props.tripPhotos.filter(photo => photo.fileUrl !== fileUrl);
    this.props.removePhoto(fileUrl)
    this.props.setTripPhotos([...newTripPhotos]);
  };
  // handleRemovePhoto = timestamp => {
  //   const newTripPhotos = this.props.tripPhotos.filter(photo => photo.timestamp !== timestamp);
  //   this.props.setTripPhotos([...newTripPhotos]);
  // };

  render() {
    const {
      rootClassName,
      className,
      isCustomer,
      isProvider,
      isPickUp,
      isShowUpload,
      intl,
      onManageDisableScrolling,
      currentUser,
      tripPhotos,
      existedPhotos,
      inputOdometerInvalid,
      pickUpReading,
      dropOffReading,
      onClick,
      holderClassName,
      title,
      description,
      type,
      onNoteChange,
      activeSection,
      id,
      inboxLabel,
      inboxPlaceholder,
      pickUpOdometer,
      isFuelInclusion,
      customDropOffReadingByAdmin,
      isAdminAction
    } = this.props;

    const { note } = this.state;

    const customerTripPhotos = existedPhotos.filter(
      photo => !!photo.isCustomer && photo[type] === true
    );
    const providerTripPhotos = existedPhotos.filter(
      photo => !photo.isCustomer && photo[type] === true
    );
    const showYourPhotos = existedPhotos.filter(
      photo => photo[type] === true
    );
    const hasJustUploadedTripPhotos = tripPhotos.filter(photo => isPickUp ? !!photo.isPickUp : !photo.isPickUp);
    const pickUpPhotos = showYourPhotos && showYourPhotos.length > 0 ? [...showYourPhotos] : [...hasJustUploadedTripPhotos];

    console.log('PICKUP PHOTOS>>', pickUpPhotos);
    console.log('PICKUP showYourPhotos>>', showYourPhotos);
    console.log('PICKUP existedPhotos>>', existedPhotos);
    console.log('PICKUP type>>', type);

    const classes = classNames(rootClassName || css.root, className);

    return (
      <div className={classNames(classes, holderClassName)}>
        <div onClick={onClick} className={classNames(css.sectionPhotoHolder)}>
          <div className={css.tickContainer}>
            <img src={(activeSection || pickUpPhotos.length > 0) ? tick : disabledTick} alt="tick" className={css.tick} />
          </div>

          <div>
            <h2 className={css.photoTitle}>{title}</h2>
            <p className={css.photoDescription}>{description}</p>
          </div>
        </div>
        <UploadSection
          isShowUpload={isShowUpload}
          isCustomer={isCustomer}
          isProvider={isProvider}
          isPickUp={isPickUp}
          onManageDisableScrolling={onManageDisableScrolling}
          setData={data => this.setState(data)}
          files={this.state.files}
          file={this.state.file}
          fileUrl={this.state.fileUrl}
          setActivePhotoSection={this.props.setActivePhotoSection}
          handleAddPhoto={this.handleUploadPhoto}
          handleRemovePhoto={this.handleRemovePhoto}
          currentUser={currentUser}
          tripPhotos={tripPhotos.map(item => {
            return { ...item, isJustUploaded: true };
          })}
          existedPhotos={existedPhotos.filter(i => type in i)}
          inputOdometerInvalid={inputOdometerInvalid}
          pickUpReading={pickUpReading}
          dropOffReading={dropOffReading}
          intl={intl}
          type={type}
          note={note}
          onNoteChange={onNoteChange}
          id={id}
          title = {title}
          inboxLabel={inboxLabel}
          inboxPlaceholder={inboxPlaceholder}
          pickUpOdometer={pickUpOdometer}
          isFuelInclusion={isFuelInclusion}
          isAdminAction={isAdminAction}
          customDropOffReadingByAdmin={customDropOffReadingByAdmin}
        />
      </div>
    );
  }
}

SectionCarPhotos.defaultProps = {
  rootClassName: null,
  className: null,
};

SectionCarPhotos.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionCarPhotos;
